module.exports = global.config = {
    // base_url: 'http://localhost/fareshare/api/'
    base_url: 'http://book.akbrothersphotography.com/api/'
    
};